import Authorization from "../../generics/authorization";
import AccountView from "./AccountView";

const pageProps = {
  workflowContainer: true,
  dashlets: [{
    component: AccountView,
    name: "accountView",
    layout: { x: 0, y: 0, w: 12, h: 45 },
    style: {
      backgroundColor: 'var(--white-bg)'
    }
  }]
};

const Page = () => (<Authorization pageProps={pageProps} />);

export default Page;
